<main class="table-page table-page--fill" dir="rtl" *ngIf="config">
  <header class="header">
    <div class="title-row">
      <button class="back" type="button" title="بازگشت" aria-label="بازگشت" (click)="goBack()"><i class="fa fa-arrow-right"></i></button>
      <div class="title-block">
        <h1 class="title">{{ definition.title }}</h1>
        <span class="muted">{{ subtitle | faNum }}</span>
      </div>
      <div class="actions" *ngIf="hasFilterSection">
        <button class="btn btn-ghost" id="filterToggle" type="button" [disabled]="loading" [attr.aria-expanded]="filtersOpen"
          aria-controls="filtersWrap" (click)="toggleFilters()">
          <i class="fa fa-sliders"></i> فیلتر
          <span class="badge" id="filterBadge" [class.show]="filterCount > 0">{{ filterCount | faNum }}</span>
          <i class="fa fa-chevron-down chev"></i>
        </button>
        <ng-container *ngIf="config.mode === 'inspection-detail'">
          <span class="actions-sep"></span>
          <button class="btn btn-ghost" type="button" [disabled]="loading || !rows.length" (click)="openFullInspectionRoute()"><i class="fa fa-map-marker"></i> مسیر حرکت</button>
          <span class="actions-sep"></span>
          <button class="btn-round" type="button" data-tip="حذف تحلیل" aria-label="حذف تحلیل" [disabled]="loading"
            (mouseenter)="tableTooltip.show($event, 'حذف تحلیل')" (mouseleave)="tableTooltip.hide()"
            (focus)="tableTooltip.show($event, 'حذف تحلیل')" (blur)="tableTooltip.hide()"
            (click)="deleteInspectionAnalysis()">
            <i class="fa fa-trash"></i>
          </button>
        </ng-container>
      </div>
    </div>

    <div class="collapsible" id="filtersWrap" [class.collapsed]="!filtersOpen" *ngIf="hasFilterSection">
      <div class="collapsible-inner">
        <div class="filters" id="filtersPanel" *ngIf="isAreaSelectionReport">
          <label class="field">
            <span class="field-label">محدوده</span>
            <select class="control" [(ngModel)]="selectedArea" (ngModelChange)="onAreaChange()" [disabled]="loading">
              <option value="">انتخاب محدوده</option>
              <option *ngFor="let area of areas" [value]="area.iGeoFence">{{ area.strTitle }}</option>
            </select>
          </label>
        </div>

        <form class="filters" id="filtersPanel" *ngIf="config.mode === 'inspection-detail'" [formGroup]="inspectionFilterForm">
          <div class="field">
            <span class="field-label">از تاریخ</span>
            <ng-persian-datepicker [uiTheme]="'gray'" [dateInitValue]="false" [timeEnable]="false"
              [uiHideAfterSelectDate]="true" [uiHideOnOutsideClick]="true"
              [dateGregorianFormat]="'YYYY/MM/DD'" [dateFormat]="'jYYYY/jMM/jDD'">
              <input class="control" type="text" formControlName="startDate" readonly>
            </ng-persian-datepicker>
          </div>
          <div class="field">
            <span class="field-label">تا تاریخ</span>
            <ng-persian-datepicker [uiTheme]="'gray'" [dateInitValue]="false" [timeEnable]="false"
              [uiHideAfterSelectDate]="true" [uiHideOnOutsideClick]="true"
              [dateGregorianFormat]="'YYYY/MM/DD'" [dateFormat]="'jYYYY/jMM/jDD'">
              <input class="control" type="text" formControlName="endDate" readonly>
            </ng-persian-datepicker>
          </div>
          <div class="filter-actions">
            <button class="btn btn-primary" type="button" [disabled]="loading" (click)="loadReport()"><i class="fa fa-search"></i> بررسی گزارش</button>
          </div>
        </form>
      </div>
    </div>
  </header>

  <section class="card">
    <div class="table-toolbar">
      <label class="search-wrap">
        <input class="control" type="search" [(ngModel)]="searchText" (ngModelChange)="onSearchChange()" [placeholder]="searchPlaceholder" [disabled]="loading">
        <i class="fa fa-search"></i>
      </label>
      <div class="toolbar-actions">
        <button class="btn btn-soft" type="button" [disabled]="loading || hasError || !filteredRows.length" [useExistingCss]="true" ngxPrint [printTitle]="definition.title" [printSectionId]="printSectionId"><i class="fa fa-print"></i> چاپ</button>
        <button class="btn btn-soft" type="button" [disabled]="loading || hasError || !filteredRows.length" (click)="exportExcel()"><i class="fa fa-file-excel-o"></i> خروجی اکسل</button>
      </div>
    </div>

    <div class="body">
      <div class="loader" [class.show]="loading" role="status" aria-live="polite"><div class="spinner"></div><span>در حال دریافت اطلاعات…</span></div>

      <div class="state" id="stEmpty" [class.show]="!loading && !hasError && filteredRows.length === 0">
        <div class="ico-big"><i class="fa fa-inbox"></i></div>
        <h4>{{ emptyTitle }}</h4>
        <span class="muted">{{ emptyDescription }}</span>
        <div class="empty-actions" *ngIf="hasActiveFilters">
          <button class="btn btn-primary" type="button" (click)="clearSearch()"><i class="fa fa-undo"></i> حذف فیلترها</button>
        </div>
      </div>

      <div class="state error" id="stError" [class.show]="hasError">
        <div class="ico-big"><i class="fa fa-exclamation-triangle"></i></div>
        <h4>دریافت اطلاعات با خطا مواجه شد</h4>
        <span class="muted">اتصال به سرور را بررسی و دوباره تلاش کنید.</span>
        <button class="btn btn-primary retry" type="button" [disabled]="loading" (click)="isAreaSelectionReport && !selectedArea ? loadAreas() : loadReport()"><i class="fa fa-refresh"></i> تلاش مجدد</button>
      </div>

      <div class="table-scroll" *ngIf="!loading && !hasError && filteredRows.length" (scroll)="tableTooltip.hide()">
        <ng-container [ngTemplateOutlet]="reportTable" [ngTemplateOutletContext]="{ tableRows: pagedRows, offset: (currentPage - 1) * pageSize }"></ng-container>
      </div>
    </div>

    <app-table-pagination [page]="currentPage" [pageSize]="pageSize" [totalItems]="filteredRows.length" [pageSizeOptions]="pageSizeOptions" (pageChange)="goToPage($event)" (pageSizeChange)="onPageSizeChange($event)"></app-table-pagination>
  </section>

  <div class="print-only" [id]="printSectionId" *ngIf="!loading && !hasError && filteredRows.length">
    <div class="table-page" dir="rtl">
      <h1 class="title">{{ definition.title }}</h1>
      <span class="muted">{{ subtitle | faNum }}</span>
      <ng-container [ngTemplateOutlet]="reportTable" [ngTemplateOutletContext]="{ tableRows: filteredRows, offset: 0, printing: true }"></ng-container>
    </div>
  </div>

  <ng-template #reportTable let-tableRows="tableRows" let-offset="offset" let-printing="printing">
    <table [id]="printing ? null : tableId">
      <thead>
        <tr>
          <th *ngFor="let column of actionColumns" class="col-ops sticky-first">{{ column.title }}</th>
          <th class="col-num">#</th>
          <th *ngFor="let column of dataColumns" [class.col-amt]="column.format === 'number'">{{ column.title }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of tableRows; let index = index" [class.pointer]="!!config.rowAction" (click)="rowClicked(row)">
          <td *ngFor="let column of actionColumns" class="col-ops sticky-first">
            <span class="row-ops no-print">
              <button class="ico" type="button" data-tip="حرکت داخل محدوده" aria-label="حرکت داخل محدوده"
                (mouseenter)="tableTooltip.show($event, 'حرکت داخل محدوده')" (mouseleave)="tableTooltip.hide()"
                (focus)="tableTooltip.show($event, 'حرکت داخل محدوده')" (blur)="tableTooltip.hide()"
                (click)="openInspectionRoute(row, 'inside', $event)"><i class="fa fa-car"></i></button>
              <button class="ico" type="button" data-tip="حرکت تا محدوده بعدی" aria-label="حرکت تا محدوده بعدی"
                (mouseenter)="tableTooltip.show($event, 'حرکت تا محدوده بعدی')" (mouseleave)="tableTooltip.hide()"
                (focus)="tableTooltip.show($event, 'حرکت تا محدوده بعدی')" (blur)="tableTooltip.hide()"
                (click)="openInspectionRoute(row, 'next', $event)"><i class="fa fa-arrow-left"></i></button>
            </span>
          </td>
          <td class="col-num">{{ offset + index + 1 | faNum }}</td>
          <td *ngFor="let column of dataColumns" [class.col-amt]="column.format === 'number'"
            [class.inspection-origin-column]="column.tone === 'origin'"
            [class.inspection-destination-column]="column.tone === 'destination'">
            <ng-container [ngSwitch]="column.format">
              <ng-container *ngSwitchCase="'number'">{{ cellValue(row, column) | number:'1.0-2' | faNum }}</ng-container>
              <span *ngSwitchCase="'status'" class="tag" [ngClass]="statusClass(row)">{{ cellValue(row, column) | faNum }}</span>
              <ng-container *ngSwitchDefault>{{ cellValue(row, column) | faNum }}</ng-container>
            </ng-container>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td *ngFor="let column of actionColumns" class="sticky-first"></td>
          <td class="label">تعداد کل: <span>{{ filteredRows.length | number | faNum }}</span></td>
          <td *ngFor="let column of dataColumns" [class.total]="column.total" [class.col-amt]="column.format === 'number'">
            <ng-container *ngIf="column.total">
              <ng-container *ngIf="column.total === 'number'; else durationTotal">{{ totalValue(column) | number:'1.0-2' | faNum }}</ng-container>
              <ng-template #durationTotal>{{ totalValue(column) | faNum }}</ng-template>
              {{ column.unit }}
            </ng-container>
          </td>
        </tr>
      </tfoot>
    </table>
  </ng-template>

  <app-table-tooltip #tableTooltip></app-table-tooltip>
</main>
